<div class="text-center py-3" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!loading">
  <div class="row mb-2">
    <div class="col-10 offset-1">
      <a href="javascript: void(0)" class="btn btn-link btn-sm" (click)="showNewDateForm = !showNewDateForm"> <i [class]="'fa fa-' + (showNewDateForm ? 'minus' : 'plus') + '-circle'"></i>&nbsp;New Matter Date </a>
      <app-matter-date-form *ngIf="showNewDateForm" [matter_id]="matter_id" (formResult)="formResult($event)"></app-matter-date-form>
    </div>
  </div>
  <table class="table" style="font-size: 82%">
    <tbody>
      <tr *ngFor="let matter_date of matter_dates">
        <th scope="row" *ngIf="!matter_date.editing" style="width: 43.5%">{{ matter_date.matter_date_type_name }}</th>
        <td *ngIf="!matter_date.editing" style="width: 30%">{{ matter_date.date_of }}</td>
        <td *ngIf="!matter_date.editing" style="width: 25%">
          <button title="Edit matter date" [disabled]="matter_date.deleting" (click)="editMatterDate(matter_date)" tooltip="Edit matter date" type="button" style="cursor: pointer" class="btn btn-outline-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
          <button title="Remove matter date" (click)="confirmMatterDateDelete(matter_date, deleteModal)" [disabled]="matter_date.deleting" tooltip="Remove matter date" type="button" style="cursor: pointer" class="btn btn-outline-danger btn-sm"><i class="fas fa-minus-circle"></i></button>
        </td>
        <td colspan="4" *ngIf="matter_date.editing">
          <div class="font-italic mb-2 text-info">Editing Matter Date</div>
          <div class="row">
            <div class="col-10 offset-1">
              <app-matter-date-form [matter_date_id]="matter_date.id" (formResult)="formResult($event, matter_date)"></app-matter-date-form>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #deleteModal let-c="close" let-d="dismiss">
  <!--<div class="modal-header">
    	<h4 class="modal-title">Modal title</h4>
    	<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
    		<span aria-hidden="true">&times;</span>
    	</button>
  	</div>-->
  <div class="modal-body">
    <p>Remove matter date - {{ matterDateToBeDeleted ? matterDateToBeDeleted.matter_date_type_name + ' ' + matterDateToBeDeleted.date_of : '' }} ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
    <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
  </div>
</ng-template>
